import { render, staticRenderFns } from "./LedInfoTable.vue?vue&type=template&id=60c31290"
import script from "./LedInfoTable.vue?vue&type=script&lang=js"
export * from "./LedInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports